export const DEBUG_MODE = false; // Set this to false for production mode